// resetUserPasswordUrl

import { useCallback, useState } from "react"
import { CellContext, ColumnDefTemplate } from "@tanstack/react-table"
import { Worker } from "src/types"
import { usersApi } from "@/fetch/api/users"
import styled from "styled-components"
import { toast } from "react-toastify"

const PointerDiv = styled.div`
  cursor: pointer;
`

export const PasswordResetCell: ColumnDefTemplate<
  CellContext<Worker, unknown>
> = ({ row }) => {
  const og = row.original
  const [loading, setLoading] = useState(false)
  const [{ url, expireAt }, setLinkData] = useState({
    url: og.changePasswordUrl,
    expireAt: og.urlExpireAt,
  })
  const onResetLink = useCallback<React.MouseEventHandler<HTMLDivElement>>(
    async (e) => {
      e?.stopPropagation?.()
      setLoading(true)
      try {
        const response = await usersApi.resetUserPasswordUrl(og.id, true)
        console.log(response)
        setLinkData({
          url: response.user.changePasswordUrl,
          expireAt: response.user.urlExpireAt,
        })
        toast("Jauns reģistrēšanās links izveidots", { type: "success" })
      } catch (error) {
        console.error(error)
        toast("Neizdevās izveidot jaunu linku, lūdzu mēģiniet vēlreiz", {
          type: "error",
        })
      } finally {
        setLoading(false)
      }
    },
    [setLoading]
  )
  const onCopyLink = useCallback<React.MouseEventHandler<HTMLDivElement>>(
    async (e) => {
      e?.stopPropagation?.()
      try {
        url && navigator.clipboard.writeText(url)
        toast("Reģistrēšanās links nokopēts", { type: "success" })
      } catch (error) {
        console.error(error)
        toast("Neizdevās nokopēt reģistrēšanās linku, lūdzu mēģiniet vēlreiz", {
          type: "error",
        })
      }
    },
    [url]
  )

  if (url != null) {
    const urlExpireAt = expireAt
      ? new Intl.DateTimeFormat("lv", {
          dateStyle: "short",
          timeStyle: "short",
        }).format(new Date(expireAt))
      : "-"
    const hasExpired =
      expireAt == null ? true : new Date(expireAt).getTime() < Date.now()
    return hasExpired ? (
      loading ? (
        <>
          <div>Veido linku...</div>
          <div className="text-[var(--error)] text-sm">Nav derīgs links</div>
        </>
      ) : (
        <>
          <PointerDiv onClick={onResetLink}>Izveidot Linku</PointerDiv>
          <div className="text-[var(--error)] text-sm">Nav derīgs links</div>
        </>
      )
    ) : (
      <>
        <PointerDiv onClick={onCopyLink}>Kopēt linku</PointerDiv>
        <div className="text-[var(--text-secondary)] text-sm">
          Derīgs līdz: {urlExpireAt}
        </div>
      </>
    )
  }
  const lastLoginAt = og.lastLoginAt
    ? new Intl.DateTimeFormat("lv", {
        dateStyle: "short",
        timeStyle: "short",
      }).format(new Date(og.lastLoginAt))
    : "-"
  return (
    <>
      <div>Aktīvs:</div>
      <div className="text-[var(--text-secondary)] text-sm">{lastLoginAt}</div>
    </>
  )
}
